export default __webpack_public_path__ + "static/media/plus.8fb03b8f.svg";